// import external dependencies

import "jquery";

// Import everything from autoload


// Import modules
import "./modules/global";
//import "./modules/calendly";
import "./modules/map";
import "./modules/resources-search";
import "./modules/video-loop";
import "./modules/compare-accordion";
import "./modules/pricing-table-adaptive";
import "./modules/free-demo-popup";

jQuery(document).ready(() => {
	const basicChecked = document.querySelector('.pricing-table__table-compare_item-basic.checked');
	if(!basicChecked){
		const basic = document.querySelectorAll('.pricing-table__table-compare_item-basic');
		basic.forEach(item => {
			item.style.display = 'none';
		});
	}
});



// WEBPACK FOOTER //
// ./scripts/main.js